import * as actionTypes from "../actionTypes";

export const send        = contactDetails => ({type: actionTypes.CONTACT_SEND, contactDetails});
export const sendSuccess = () => ({type: actionTypes.CONTACT_SEND_SUCCESS});
export const sendFail    = error => ({type: actionTypes.CONTACT_SEND_FAIL, error});

export const clearError = () => ({type: actionTypes.CONTACT_RESET_ERROR});
